import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'next-i18next';
interface Props {
  title: string;
  description?: string;
  children: React.ReactNode;
}
const Base = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const CategoryHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
const CategoryTitle = styled.span`
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: ${({
  theme
}) => theme.color.content12};

  ${({
  theme
}) => theme.screenSize.mobile} {
    font-size: 14px;
    line-height: 21px;
  }
`;
const CategoryDescription = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 15px;
  color: ${({
  theme
}) => theme.color.content9};
`;
const Category: React.FC<Props> = ({
  title,
  description,
  children
}) => {
  const {
    t
  } = useTranslation();
  return <Base data-sentry-element="Base" data-sentry-component="Category" data-sentry-source-file="Category.tsx">
      <CategoryHeader data-sentry-element="CategoryHeader" data-sentry-source-file="Category.tsx">
        <CategoryTitle data-sentry-element="CategoryTitle" data-sentry-source-file="Category.tsx">{t(title)}</CategoryTitle>
        {description && <CategoryDescription>{t(description)}</CategoryDescription>}
      </CategoryHeader>
      {children}
    </Base>;
};
export default Category;